var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("h3", { staticStyle: { margin: "1rem", "font-size": "1.4rem" } }, [
        _vm._v("平台销售报表")
      ]),
      _c(
        "div",
        { staticClass: "block" },
        [
          _c("span", { staticClass: "demonstration" }, [_vm._v("选择日期")]),
          _c("el-date-picker", {
            staticStyle: { width: "20rem !important" },
            attrs: {
              editable: false,
              size: "small",
              type: "daterange",
              "range-separator": "~",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "value-format": "timestamp",
              "picker-options": _vm.pickerOptionsLimit
            },
            model: {
              value: _vm.datePickerValue,
              callback: function($$v) {
                _vm.datePickerValue = $$v
              },
              expression: "datePickerValue"
            }
          }),
          _c(
            "el-select",
            {
              attrs: {
                "value-key": "statTag",
                size: "small",
                placeholder: "请选择站点"
              },
              model: {
                value: _vm.selectedStation,
                callback: function($$v) {
                  _vm.selectedStation = $$v
                },
                expression: "selectedStation"
              }
            },
            [
              _c("el-option", {
                attrs: { label: "请选择站点", value: 0, disabled: "" }
              }),
              _vm._l(_vm.asyncStations, function(item) {
                return _c("el-option", {
                  key: item.ID,
                  attrs: { label: item.statTag, value: item }
                })
              })
            ],
            2
          ),
          _c(
            "el-button",
            {
              attrs: {
                loading: _vm.downloadLoading,
                size: "small",
                type: "primary"
              },
              on: { click: _vm.loadData }
            },
            [_vm._v("查询")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                loading: _vm.downloadLoading,
                size: "small",
                type: "warning",
                icon: "el-icon-document"
              },
              on: {
                click: function($event) {
                  return _vm.exportExcel(_vm.excelSheets, "平台销售报表")
                }
              }
            },
            [_vm._v(" 下载报表 ")]
          )
        ],
        1
      ),
      _c("br"),
      _c(
        "el-table",
        {
          ref: "stationDailyPlatformData",
          staticStyle: { width: "100%" },
          attrs: {
            id: "stationDailyPlatformData",
            data: _vm.stationDailyPlatformData,
            "show-summary": "",
            "sum-text": "合计",
            "highlight-current-row": "",
            border: "",
            height: "640"
          }
        },
        [
          _c(
            "el-table-column",
            { attrs: { align: "center", label: "站点" } },
            [[_vm._v(_vm._s(_vm.selectedStation.statTag))]],
            2
          ),
          _c("el-table-column", {
            attrs: { align: "center", prop: "platName", label: "平台" }
          }),
          _c(
            "el-table-column",
            { attrs: { align: "center", label: "合计" } },
            [
              _c("el-table-column", {
                attrs: { align: "center", prop: "nums", label: "升数" }
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "total", label: "应收" }
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "amount", label: "实收" }
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "discount", label: "优惠" }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            { attrs: { align: "center", label: "0#柴油" } },
            [
              _c("el-table-column", {
                attrs: { align: "center", prop: "nums0", label: "升数" }
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "total0", label: "应收" }
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "amount0", label: "实收" }
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "discount0", label: "优惠" }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            { attrs: { align: "center", label: "92#汽油" } },
            [
              _c("el-table-column", {
                attrs: { align: "center", prop: "nums92", label: "升数" }
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "total92", label: "应收" }
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "amount92", label: "实收" }
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "discount92", label: "优惠" }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            { attrs: { align: "center", label: "95#汽油" } },
            [
              _c("el-table-column", {
                attrs: { align: "center", prop: "nums95", label: "升数" }
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "total95", label: "应收" }
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "amount95", label: "实收" }
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "discount95", label: "优惠" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }